import SettingsOfficeHeader from "./SettingsHeader";
import OfficeAddress from "./OfficeAddress";
import UserManual from "./UserManual";
import EmailUpdate from "./EmailUpdate";
import ResetPassword from "./ResetPassword";

export {
  SettingsOfficeHeader,
  OfficeAddress,
  UserManual,
  EmailUpdate,
  ResetPassword,
};
